import React from 'react';
import { useSelector } from 'react-redux';
import { selectAuthUser } from '../../features/auth';
import { Navigate, Outlet } from 'react-router-dom';

const PublicRoute = () => {
  const user = useSelector(selectAuthUser);
  const storeduser = JSON.parse(localStorage.getItem('user'));

  if (user || storeduser) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default PublicRoute;
